(function () {
  function swiperInit(section) {
    if (!section) return;
    const galleryWrapper = section.querySelector(".product__main");
    if (!galleryWrapper) return;
    const galleryLayout = galleryWrapper.dataset.layout || "gallery";
    const galleryLayoutMobile = galleryWrapper.dataset.layoutMobile || "slider";

    let isSwiperActive = false;
    function checkAndToggleSlider(entry) {
      const viewportWidth = window.innerWidth;

      const shouldEnableSlider =
        (viewportWidth < 990 && galleryLayoutMobile === "slider") ||
        (viewportWidth >= 990 && galleryLayout === "slider");

      if (shouldEnableSlider && !isSwiperActive) {
        subSliderInit(section);
        sliderInit(section);

        isSwiperActive = true;
      } else if (!shouldEnableSlider && isSwiperActive) {
        subSliderDestroy(section);
        sliderDestroy(section);

        isSwiperActive = false;
      }
    }

    let resizeObserver = new ResizeObserver((entries) => {
      entries.forEach(checkAndToggleSlider);
    });

    resizeObserver.observe(section);
    popupSliderInit(section);
    rooviaPopupZoomClickInit(section);
  }

  function rooviaPopupZoomClickInit(section) {
    const sliderWrapper =
      section?.querySelector?.(".js-popup-slider") ||
      document.querySelector(".product-media-modal .js-popup-slider") ||
      document.querySelector(".js-popup-slider");

    if (!sliderWrapper) return;
    if (sliderWrapper.dataset.rooviaZoomClickBound === "true") return;

    sliderWrapper.dataset.rooviaZoomClickBound = "true";

    const resetPopupZoom = () => {
      const swiper = sliderWrapper.swiper;

      try {
        if (swiper?.zoom?.out) swiper.zoom.out();
      } catch (error) {
        console.warn("ROOVIA product zoom reset skipped:", error);
      }

      sliderWrapper.classList.remove("zoom");

      sliderWrapper.querySelectorAll(".swiper-slide-zoomed").forEach((slide) => {
        slide.classList.remove("swiper-slide-zoomed");
      });

      sliderWrapper.querySelectorAll(".swiper-zoom-container").forEach((container) => {
        container.style.transform = "translate3d(0px, 0px, 0px)";
      });

      sliderWrapper.querySelectorAll(".swiper-zoom-target").forEach((image) => {
        image.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
      });
    };

    const bindSwiperSafetyEvents = (attempt = 0) => {
      const swiper = sliderWrapper.swiper;

      if (!swiper) {
        if (attempt < 30) {
          window.requestAnimationFrame(() => bindSwiperSafetyEvents(attempt + 1));
        }
        return;
      }

      if (swiper.rooviaZoomSafetyBound === true) return;
      swiper.rooviaZoomSafetyBound = true;

      if (swiper.on) {
        swiper.on("slideChange", resetPopupZoom);
        swiper.on("touchMove", () => {
          sliderWrapper.classList.remove("zoom");
        });
      }
    };

    sliderWrapper.addEventListener("click", (event) => {
      const swiper = sliderWrapper.swiper;
      if (!swiper || !swiper.zoom) return;
      if (swiper.allowClick === false) return;

      const activeSlide =
        swiper.slides?.[swiper.activeIndex] ||
        sliderWrapper.querySelector(".swiper-slide-active");

      if (!activeSlide) return;
      if (!activeSlide.contains(event.target)) return;

      const zoomContainer = activeSlide.querySelector(".swiper-zoom-container");
      const zoomTarget = activeSlide.querySelector(".swiper-zoom-target");

      if (!zoomContainer || !zoomTarget) return;
      if (!event.target.closest(".swiper-zoom-container")) return;

      event.preventDefault();

      try {
        const isZoomed = activeSlide.classList.contains("swiper-slide-zoomed");

        if (isZoomed) {
          if (swiper.zoom.out) swiper.zoom.out();
          sliderWrapper.classList.remove("zoom");
        } else {
          if (swiper.zoom.in) swiper.zoom.in(event);
          sliderWrapper.classList.add("zoom");
        }
      } catch (error) {
        console.warn("ROOVIA product zoom click skipped:", error);
      }
    });

    const modal = sliderWrapper.closest("product-modal, .product-media-modal");
    const closeButton = modal?.querySelector?.(".product-media-modal__toggle, .modal-close-button");

    closeButton?.addEventListener?.("click", resetPopupZoom);

    document.body.addEventListener("modalClosed", resetPopupZoom);

    document.addEventListener("keyup", (event) => {
      if (event.code && event.code.toUpperCase() === "ESCAPE") {
        resetPopupZoom();
      }
    });

    bindSwiperSafetyEvents();
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit(e.target);
  });

  swiperInit(document.currentScript?.parentElement);
})();